import { lightPalettes, useCustomTheme } from 'pixelize-design-library';
import { useMemo } from 'react';

import { DEFAULT_BRAND } from '@core/store/Settings/settingsStorage';

export type AppTheme = ReturnType<typeof useCustomTheme>;

/**
 * The one colour entry point. Chakra's `useTheme` yields emotion's `{}` default when a
 * component renders outside a provider (a portal under test, a storybook-less unit render),
 * and every `theme.colors.<x>` read then throws — so fall back to a complete brand palette
 * rather than letting a missing key crash the tree.
 *
 * Always `useAppTheme()`, never `useCustomTheme()` directly.
 */
export const useAppTheme = (): AppTheme => {
  const theme = useCustomTheme();
  return useMemo(
    () => (theme.colors ? theme : ({ ...theme, colors: lightPalettes[DEFAULT_BRAND] } as AppTheme)),
    [theme]
  );
};

/** Shorthand for the common case — a component that only needs the palette. */
export const useAppColors = (): AppTheme['colors'] => useAppTheme().colors;
